import axios from "axios";
import { getOptions } from "../../helpers/api";

export const general = {
  backendRedirection: (data) => {
    const { params, headers } = getOptions(data);
    return axios.post("/ntww_odp/ntww_odp_redirection", params, headers)
  },

  getUsers: (data, cancelToken) => {
    const { headers } = getOptions(data);
    return axios.get(`/mashhad.api/UserManagement/users?roles=${data.role || 'Inspector'}&q${data.search}`, {...headers, cancelToken});
  },

  getAllUsers: (data, cancelToken) => {
    const { headers } = getOptions(data);
    return axios.get(`/mashhad.api/UserManagement/users`, {...headers, cancelToken});
  },

  saveUser: (data, cancelToken) => {
    const { headers } = getOptions(data);
    return axios.post(`/mashhad.api/UserManagement/SaveUser`, data.body, {...headers, cancelToken});
  },


  getIncidents: (data, cancelToken) => {
    const { headers } = getOptions(data);
    return axios.post(`/mashhad.api/Incident/GetIncidents`, data, {...headers, cancelToken});
  },

  getIncidentDetails: (data, cancelToken) => {
    const { headers } = getOptions(data);
    return axios.get(`/mashhad.api/Incident/GetIncidentDetails?incidentId=${data.Id}`, {...headers, cancelToken});
  },
    
  getFilterLookups: (data, cancelToken) => {
    const { headers } = getOptions(data);
    // return axios.get(`/mashhad.api/Incident/GetFilterLookups?Campaign=${data.Campaign}&City=${data.City}&MainElement=${data.MainElement}`, headers);
    return axios.get(`/mashhad.api/Incident/GetFilterLookups?Campaign=${data.Campaign || ''}&CampaignType=${data.CampaignType || ''}&National=${data.National || ''}&Initiative=${data.Initiative || ''}&City=${data.City || ''}&PriorityType=${data.priorityType ? data.priorityType?.replace(/\+/g, "%2B") : ''}&DistrictPart=${data.DistrictPart || ''}&MainElement=${data.MainElement || ''}`, {...headers, cancelToken});
  },

  getSmartSupervisionSummary: (data, cancelToken) => {
    const { headers } = getOptions(data);
    return axios.post(`/mashhad.api/Incident/GetSmartSupervisionSummary`, data, {...headers, cancelToken});
  },

  getDetectionQualityIncidents: (data, cancelToken) => {
    const { headers } = getOptions(data);
    return axios.post(`/mashhad.api/DetectionQuality/GetDetectionQualityIncidents`, data.body, {...headers, cancelToken});
  },

  getDetectionQualityIncidentDetails: (data, cancelToken) => {
    const { headers } = getOptions(data);
    return axios.get(`/mashhad.api/DetectionQuality/GetDetectionQualityIncidentDetails?incidentId=${data.Id}`, {...headers, cancelToken});
  },
    
  getDetectionQualityFilterLookups: (data, cancelToken) => {
    const { headers } = getOptions(data);
    return axios.get(`/mashhad.api/DetectionQuality/GetDetectionQualityFilters?Stage=${data.Stage || ''}&Type=${data.Type || ''}&MainStream=${data.MainStream || ''}&SubStream=${data.SubStream || ''}&Element=${data.Element || ''}`, {...headers, cancelToken});
  },

  getDetectionQualitySummary: (data, cancelToken) => {
    const { headers } = getOptions(data);
    return axios.post(`/mashhad.api/DetectionQuality/GetDetectionQualityData`, data.body, {...headers, cancelToken});
  },

  getSummary: (data, cancelToken) => {
    const { headers } = getOptions(data);
    return axios.post(`/mashhad.api/Incident/GetSummaryDashboardData`, data.body, {...headers, cancelToken});
  },
  
  getLastRefreshDate: (data, cancelToken) => {
    const { headers } = getOptions(data);
    return axios.get(`/mashhad.api/Incident/GetLastRefreshDate`, {...headers, cancelToken});
  },

  saveDashboardFilters: (data, cancelToken) => {
    const { headers } = getOptions(data);
    return axios.post(`/mashhad.api/Incident/SaveDashboardFilters`, data.body, {...headers, cancelToken});
  },

  getDashboardFilters: (data, cancelToken) => {
    const { headers } = getOptions(data);
    return axios.get(`/mashhad.api/Incident/GetDashboardFilters`, {...headers, cancelToken});
  },
  
  getMunicipalityAndStreetData: (data, cancelToken) => {
    const { headers } = getOptions(data);
    return axios.get(`/mashhad.api/Incident/GetMunicipalityAndStreetData?Municipality=${data.municipality}&City=${data.city}&PriorityType=${data.priorityType ? data.priorityType?.replace(/\+/g, "%2B") : ''}&DistrictPart=${data.districtPart}&Month=${data.month}&Campaign=${data.campaign}`, {...headers, cancelToken});
  },

  getMunicipalityAndStreetDataSmartSupervision: (data, cancelToken) => {
    const { headers } = getOptions(data);
    return axios.get(`/mashhad.api/Incident/GetMunicipalityAndStreetDataSmartSupervision?Municipality=${data.municipality}&City=${data.city}&Layer=${data.layer}`, {...headers, cancelToken});
  },

  getHighElementsData: (data, cancelToken) => {
    const { headers } = getOptions(data);
    return axios.get(`/mashhad.api/Incident/GetHighElements?Municipality=${data.municipality}&City=${data.city}&DistrictPart=${data.districtPart}`, {...headers, cancelToken});
  },

  getVPIData: (data, cancelToken) => {
    const { headers } = getOptions(data);
    return axios.get(`/mashhad.api/Incident/GetStreetAndDistrictVPI?Municipality=${data.municipality}&City=${data.city}&DistrictPart=${data.districtPart}`, {...headers, cancelToken});
  },
  
  getCoverageStreetData: (data, cancelToken) => {
    const { headers } = getOptions(data);
    return axios.get(`/mashhad.api/Incident/GetStreetData?Municipality=${data.municipality}&City=${data.city}&DistrictPart=${data.districtPart}`, {...headers, cancelToken});
  },

  getVPITrends: (data, cancelToken) => {
    const { headers } = getOptions(data);
    return axios.get(`/mashhad.api/Incident/GetVPITrends`, {...headers, cancelToken});
  },

  getStreetCoverage: (data, cancelToken) => {
    const { headers } = getOptions(data);
    return axios.get(`/mashhad.api/Incident/GetStreetCoverage?Street=${data.street}&Campaign=${data.campaign}`, {...headers, cancelToken});
  },

  getRoadOptions: (data, cancelToken) => {
    const { headers } = getOptions(data);
    return axios.get(`/mashhad.api/Incident/GetRoads?Municipality=${data.municipality}&page=0&SearchText=${data.SearchText}&City=${data.city}&DistrictPart=${data.districtPart}`, {...headers, cancelToken});
  },

  getCoverageProgress: (data, cancelToken) => {
    const { headers } = getOptions(data);
    return axios.post(`/mashhad.api/Incident/GetIncidentCoverageProgress`, data.body, {...headers, cancelToken});
  },

  getRecentIncidentsHeatmap: (data, cancelToken) => {
    const { headers } = getOptions(data);
    return axios.get(`/mashhad.api/Incident/GetRecentIncidentsHeatmap`, { ...headers, cancelToken });
  },

  getRecentIncidentsHeatmapDetails: (data, cancelToken) => {
    const { headers } = getOptions(data);
    return axios.post(`/mashhad.api/Incident/GetRecentIncidentsHeatmapDetails`, data.body, {...headers, cancelToken});
  },

  getRecentIncidentHeatmapLookUps: (data, cancelToken) => {
    const { headers } = getOptions(data);
    return axios.get('/mashhad.api/Incident/GetRecentIncidentHeatmapLookUps', { ...headers, cancelToken });
  },


  getPowerBIConfig: (data) => {
    // return axios.post(`https://mashhaddevfunction.azurewebsites.net/api/HttpTrigger1?code=GKi_34SxW4tRfidqdNDQs589AIDwKNZtuyD62K50UdvIAzFu5clmtA==&Id=${data.Id}`,
    return axios.post(`https://mashhadpowerbi.azurewebsites.net/api/MashahadPowerBI?code=0d1A4jKoUwWx9-76_HH0zws1i4ca0tt-Xx-1Kk0C15LMAzFuTJckgQ==`,
    // return axios.post(`http://localhost:5001/getEmbedUrl`,
      { reportId: data.Id, username: data.username, role: data.role },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
  },

  getSummaryDashboardDataDetails: (data, cancelToken) => {
    const { headers } = getOptions(data);
    return axios.post(`/mashhad.api/Incident/GetSummaryDashboardDataDetails`, data.body, {...headers, cancelToken});
  },

  getDepartments: (data, cancelToken) => {
    const { headers } = getOptions(data);
    return axios.get("/mashhad.api/Department/GetLookups", {...headers, cancelToken});
  },
  getDepartmentDataSummary: (data, cancelToken) => {
    const { headers } = getOptions(data);
    return axios.post("/mashhad.api/Department/GetDepartmentDataSummary", data.body, {...headers, cancelToken});
  },




};
